import type { Theme } from 'theme-ui';

export const images: Theme['images'] = {
	avatar: {
		height: 32,
		width: 32,
		borderRadius: 'full',
	},
};
